// NOTE TO MAINTAINER:
// Done this way to allow local dev builds to not fail if messages are not built.

// Normally this rule is great, but we're doing somthing unconventional.
// eslint-disable-next-line import/no-mutable-exports
let Messages;

try {
    Messages = require('../../../../locale/fr.json');
} catch (e) {
    if (process.env.NODE_ENV === 'production') {
        throw new Error('Unable to load french messages');
    }

    // eslint-disable-next-line no-console
    console.warn('[WARNING] fr.json not found - run "npm run langs:build" to create');
    Messages = {};
}

export default Messages;
